import { REDUX_VIEW_TYPES } from 'tennders-common/stores/view/action'
import { REDUX_DATA_TYPES } from './action'

const initialState = {
  carriers: [],
  shippers: [],
  teams: [],
  selectedRows: {}
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_DATA_TYPES.MATCH_LOADS:
      return {
        ...state,
        matchLoads: action.payload
      }
    case REDUX_DATA_TYPES.SHOW_MARKETPLACE:
      return {
        ...state,
        showMarketplace: action.payload
      }
    case REDUX_DATA_TYPES.TAG:
      return {
        ...state,
        tag: action.payload
      }
    case REDUX_DATA_TYPES.CARRIERS:
      return {
        ...state,
        carriers: action.payload
      }
    case REDUX_DATA_TYPES.SHIPPERS:
      return {
        ...state,
        shippers: action.payload
      }
    case REDUX_DATA_TYPES.SELECTED_ROWS:
      return {
        ...state,
        selectedRows: {
          ...state.selectedRows,
          ...action.payload
        }
      }
    case REDUX_DATA_TYPES.RESET_SELECTED_ROWS:
      return {
        ...state,
        selectedRows: {}
      }
    case REDUX_VIEW_TYPES.SHARE_MODE:
      return {
        ...state,
        selectedRows: []
      }
    case REDUX_DATA_TYPES.TEAMS:
      return {
        ...state,
        teams: action.payload
      }
    default:
      return state
  }
}
